export default __webpack_public_path__ + "2727b98.png";